import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as DocumentSubCategoryActions from './document-sub-category.actions';
import { DocumentSubCategoryService } from '../../services/document-sub-category.service';

@Injectable()
export class DocumentSubCategoryEffects {
  loadDocumentSubCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentSubCategoryActions.loadDocumentSubCategory),
      exhaustMap((_) =>
        this.documentSubCategoryService.getDocumentSubCategory().pipe(
          map((data) =>
            DocumentSubCategoryActions.loadDocumentSubCategorySuccess({
              documentSubCategory: data,
            })
          ),
          catchError((error) =>
            of(
              DocumentSubCategoryActions.loadDocumentSubCategoryFailure({
                error,
              })
            )
          )
        )
      )
    )
  );

  addDocumentSubCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentSubCategoryActions.addDocumentSubCategory),
      concatMap(({ newDocumentSubCategory }) =>
        this.documentSubCategoryService
          .createDocumentSubCategory(newDocumentSubCategory)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return DocumentSubCategoryActions.addDocumentSubCategorySuccess({
                newDocumentSubCategory: data,
              });
            }),
            catchError((error) =>
              of(
                DocumentSubCategoryActions.addDocumentSubCategoryFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateDocumentSubCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentSubCategoryActions.updateDocumentSubCategory),
      map((action) => action.updateDocumentSubCategory),
      concatMap((updateDocumentSubCategory) =>
        this.documentSubCategoryService
          .updateDocumentSubCategory(updateDocumentSubCategory)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return DocumentSubCategoryActions.updateDocumentSubCategorySuccess(
                {
                  updateDocumentSubCategory: updateDocumentSubCategory,
                }
              );
            }),
            catchError((error) =>
              of(
                DocumentSubCategoryActions.updateDocumentSubCategoryFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeDocumentSubCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentSubCategoryActions.removeDocumentSubCategory),
      map((action) => action.ids),
      concatMap((ids) =>
        this.documentSubCategoryService.deleteDocumentSubCategory(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return DocumentSubCategoryActions.removeDocumentSubCategorySuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              DocumentSubCategoryActions.updateDocumentSubCategoryFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private documentSubCategoryService: DocumentSubCategoryService,
    private notification: NotificationService
  ) {}
}
